var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6199 9.09021C16.6199 7.62355 16.2532 6.25688 15.5199 4.99022C14.7999 3.76355 13.8265 2.79021 12.5999 2.07022C11.3332 1.33688 9.96655 0.970215 8.49988 0.970215C7.03322 0.970215 5.66655 1.33688 4.39988 2.07022C3.17322 2.79021 2.19988 3.76355 1.47988 4.99022C0.746549 6.25688 0.379883 7.62355 0.379883 9.09021C0.379883 10.3702 0.666549 11.5835 1.23988 12.7302C1.78655 13.8369 2.55322 14.7702 3.53988 15.5302L8.57988 20.9702L13.5599 15.4502C14.5065 14.6769 15.2465 13.7502 15.7799 12.6702C16.3399 11.5502 16.6199 10.3569 16.6199 9.09021ZM8.51988 6.73022C8.94655 6.73022 9.33988 6.83688 9.69988 7.05021C10.0599 7.26355 10.3465 7.55021 10.5599 7.91022C10.7732 8.27022 10.8799 8.66355 10.8799 9.09021C10.8799 9.51688 10.7732 9.91355 10.5599 10.2802C10.3465 10.6469 10.0599 10.9369 9.69988 11.1502C9.33988 11.3635 8.94655 11.4702 8.51988 11.4702C8.09322 11.4702 7.69988 11.3635 7.33988 11.1502C6.97988 10.9369 6.69322 10.6469 6.47988 10.2802C6.26655 9.91355 6.15988 9.51688 6.15988 9.09021C6.15988 8.66355 6.26655 8.26688 6.47988 7.90022C6.69322 7.53355 6.97988 7.24688 7.33988 7.04022C7.69988 6.83355 8.09322 6.73022 8.51988 6.73022Z",
    fill: "#EFF0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.7d1dba07171636a14fe97fd7a78c1302.svg";
export { ForwardRef as ReactComponent };